export default __webpack_public_path__ + "static/media/screen-battery replacement.f501b8dd.svg";